module.exports = __webpack_public_path__ + "img/foto_urs_wegrhoff_mediurs.9d20cd87.jpg";